import { useMemo } from 'react';
import classNames from 'classnames';
import BootstrapForm from 'react-bootstrap/Form';

import ELEMENT from 'common/element';
import { generateRandomHash } from 'common/util/generator';

import './Switch.scss';

type SwitchProps = {
  checked:  boolean;
  onChange: (checked: boolean) => void;
  label?:   string;
  id?:      string;
  testId?:  ELEMENT;
};

/**
 * Switch component for on/off functionality. Wraps the Bootstrap version.
 *
 * @prop checked     sets on/off state
 * @prop onChange    callback that triggers when the switch is toggles
 * @prop label       text associated with the switch
 * @prop id          element ID (useful if there is an associated label)
 * @prop testId      Test id for testing
 */
function Switch({
  checked,
  onChange,
  label = '', // always should be present
  id, testId,
}: SwitchProps): JSX.Element {
  // always should be uniquely set in Bootstrap {@see https://github.com/react-bootstrap/react-bootstrap/issues/4767#issuecomment-549772834}
  const elId = useMemo(() => id ?? generateRandomHash(), [id]);

  const classes = classNames(
    'Switch',
    checked ? 'Switch--On' : 'Switch--Off',
  );

  return (
    <BootstrapForm.Check
      type="switch"
      checked={checked}
      className={classes}
      onChange={(): void => onChange(!checked)}
      label={label}
      id={elId}
      data-test-id={testId}
    />
  );
}

export default Switch;
